module.exports = __webpack_public_path__ + "static/media/CpuBanner.48beae71.png";